export default {
  title: "AccuTrax.id"
};
